﻿$.fn.dxCtrlBuilderEmailStyleRadius = function custom_dxCtrlBuilderEmailStyleRadius(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlbuilderemailstyleradius dx-ctrl");
        this.createInstance(new cdxCtrlBuilderEmailStyleRadius(this, option));
    }
    return this;
}

window.cdxCtrlBuilderEmailStyleRadius = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var radiusGrouper = null
    var etat = null
    var $DivModif = null;
    function mConstruit() {
        container.empty()

        if (radiusGrouper == null) {
            if (option.radiusTopRight == "") {
                etat = "Défaut"
                radiusGrouper = true
            } else {
                radiusGrouper = (option.radiusTopRight == option.radiusBottomRight && option.radiusTopLeft == option.radiusBottomLeft && option.radiusTopRight == option.radiusTopLeft)
                if (radiusGrouper) {
                    etat = ((option.radiusTopRight == "0" || option.radiusTopRight == "0px") ? "Carré" : ((option.radiusTopRight == "10px") ? "Arrondi" : ((option.radiusTopRight == "100px") ? "Ovale" : "...")))
                } else {
                    etat = "..."
                }
            }
        }

        var ds = ["Carré", "Arrondi", "Ovale", "..."]
        if (option.allowDefaut) ds.unshift("Défaut")
        $("<div/>").appendTo(container).dxCtrlRadioButton({
            dataSource: ds,
            value: etat,
            layout: 'horizontal',
            itemTemplate: function (itemData, itemIndex, itemElement) {
                if (itemData == "Défaut") {
                    itemElement.html("<i class='fas fa-text-slash'></i>")
                    itemElement.attr("title", "Utiliser le style par défaut")
                } else {
                    itemElement.text(itemData)
                    itemElement.attr("title", itemData)
                }
            },
            onValueChanged: function (e) {
                etat = e.value
                switch (e.value) {
                    case "Défaut":
                        $DivModif.empty()
                        radiusGrouper = true
                        var newValues = mGetNewValue("", "", "", "")
                        option.onValueChanged(newValues);
                        break;
                    case "Carré":
                        $DivModif.empty()
                        radiusGrouper = true
                        var newValues = mGetNewValue("0px", "0px", "0px", "0px")
                        option.onValueChanged(newValues);
                        break;
                    case "Arrondi":
                        $DivModif.empty()
                        radiusGrouper = true
                        var newValues = mGetNewValue("10px", "10px", "10px", "10px")
                        option.onValueChanged(newValues);
                        break;
                    case "Ovale":
                        $DivModif.empty()
                        radiusGrouper = true
                        var newValues = mGetNewValue("100px", "100px", "100px", "100px")
                        option.onValueChanged(newValues);
                        break;
                    case "...":
                        mRempliSaisie()
                        break;
                }
            }
        })

        $DivModif = $("<div style=''/>").appendTo(container)
        if (etat == "...") mRempliSaisie()

    }

    function mRempliSaisie() {
        $DivModif.empty()

        $("<div/>").appendTo($DivModif).dxCheckBox({
            text: "Tous les cotés identiques",
            value: radiusGrouper,
            onValueChanged: function (e) {
                radiusGrouper = e.value
                var nVal = option.radiusTopRight + ((option.radiusTopRight.toString().length > 0) ? "px" : "")
                var newValues = mGetNewValue(nVal, nVal, nVal, nVal)
                option.onValueChanged(newValues);
                mConstruit()
            }
        })

        if (radiusGrouper) {
            var timeOutSlider = null
            var dxSliderRadius = $("<div/>").appendTo($DivModif).dxSlider({
                min: 0,
                max: 120,
                value: parseInt(option.radiusTopLeft.replace("px", "")),
                onValueChanged: function (e) {
                    window.clearTimeout(timeOutSlider)
                    timeOutSlider = window.setTimeout(function () {
                        var val = ((isNaN(e.value)) ? "" : e.value + "px")
                        var newValues = mGetNewValue(val, val, val, val)
                        option.onValueChanged(newValues);
                    }, 1000)
                },
                tooltip: {
                    enabled: true,
                    format(value) {
                        if (isNaN(value)) { return `Radius: Défaut`; }
                        else { return `Radius: ${value}px`; }
                    },
                    showMode: 'always',
                    position: 'bottom',
                },
                onContentReady: function (e) { window.setTimeout(function () { e.component.repaint() }, 0) }
            }).dxSlider("instance")
        } else {
            var $DivDetail = $("<div/>").appendTo($DivModif)
            var $Table = $("<table style=''/>").appendTo($DivDetail)
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='width:50%;padding:10px;'/>").appendTo($Tr)
            $("<div style='width:150px;'/>").appendTo($Td).dxCtrlWidgetNumber({
                label: "Coin haut gauche",
                placeholder: "Défaut",
                noNull: !option.allowDefaut,
                value: ((option.radiusTopLeft.length == 0) ? null : option.radiusTopLeft),
                onValueChanged: function (e) {
                    var newValues = mGetNewValue(option.radiusTopRight, option.radiusBottomRight, option.radiusBottomLeft, ((e.value == null) ? "" : e.value + "px"))
                    option.onValueChanged(newValues);
                }
            })
            var $Td = $("<td style='width:50%;padding:10px;'/>").appendTo($Tr)
            $("<div style='width:150px;'/>").appendTo($Td).dxCtrlWidgetNumber({
                label: "Coin haut droit",
                placeholder: "Défaut",
                noNull: !option.allowDefaut,
                value: ((option.radiusTopRight.length == 0) ? null : option.radiusTopRight),
                onValueChanged: function (e) {
                    var newValues = mGetNewValue(((e.value == null) ? "" : e.value + "px"), option.radiusBottomRight, option.radiusBottomLeft, option.radiusTopLeft)
                    option.onValueChanged(newValues);
                }
            })
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='width:50%;padding:10px;'/>").appendTo($Tr)
            $("<div style='width:150px;'/>").appendTo($Td).dxCtrlWidgetNumber({
                label: "Coin bas gauche",
                placeholder: "Défaut",
                noNull: !option.allowDefaut,
                value: ((option.radiusBottomLeft.length == 0) ? null : option.radiusBottomLeft),
                onValueChanged: function (e) {
                    var newValues = mGetNewValue(option.radiusTopRight, option.radiusBottomRight, ((e.value == null) ? "" : e.value + "px"), option.radiusTopLeft)
                    option.onValueChanged(newValues);
                }
            })
            var $Td = $("<td style='width:50%;padding:10px;'/>").appendTo($Tr)
            $("<div style='width:150px;'/>").appendTo($Td).dxCtrlWidgetNumber({
                label: "Coin bas droit",
                placeholder: "Défaut",
                noNull: !option.allowDefaut,
                value: ((option.radiusBottomRight.length == 0) ? null : option.radiusBottomRight),
                onValueChanged: function (e) {
                    var newValues = mGetNewValue(option.radiusTopRight, ((e.value == null) ? "" : e.value + 'px'), option.radiusBottomLeft, option.radiusTopLeft)
                    option.onValueChanged(newValues);
                }
            })

        }


    }

    function mGetNewValue(radiusTopRight, radiusBottomRight, radiusBottomLeft, radiusTopLeft) {
        var newValue = {
            values: [
                { prop: "border-top-right-radius", value: radiusTopRight, oldValue: option.radiusTopRight },
                { prop: "border-bottom-right-radius", value: radiusBottomRight, oldValue: option.radiusBottomRight },
                { prop: "border-bottom-left-radius", value: radiusBottomLeft, oldValue: option.radiusBottomLeft },
                { prop: "border-top-left-radius", value: radiusTopLeft, oldValue: option.radiusTopLeft }
            ]
        }
        option.radiusTopRight = radiusTopRight
        option.radiusBottomRight = radiusBottomRight
        option.radiusBottomLeft = radiusBottomLeft
        option.radiusTopLeft = radiusTopLeft
        return newValue
    }

    this.element = function () { return container }

    mConstruit();
}